'use client'

import { useState } from 'react'
import Link from 'next/link'

export function ScheduleAlert() {
  const [dismissed, setDismissed] = useState(false)
  if (dismissed) return null

  return (
    <div className="relative mx-auto mt-6 max-w-5xl px-6">
      <div className="flex items-start gap-4 rounded-lg border-2 border-amber-400 bg-amber-50 p-4 shadow-md">
        {/* Blinking indicator */}
        <div className="mt-0.5 flex-shrink-0">
          <span className="relative flex h-3 w-3">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber-400 opacity-75" />
            <span className="relative inline-flex h-3 w-3 rounded-full bg-amber-500" />
          </span>
        </div>

        <div className="flex-1">
          <p className="font-semibold text-amber-900">⚠️ Updated Schedule — April 12</p>
          <p className="mt-1 text-sm text-amber-800">
            The April 12 schedule has been updated. Two games: <strong>11:00 AM</strong> (WPI vs St. Anselm) and <strong>1:30 PM</strong> (WIT vs MMA) at ICC, Canton. Women's Showcase at 12:20 PM. Awards at 3:00 PM.
          </p>
          <Link
            href="/schedule"
            className="mt-2 inline-block text-sm font-semibold text-amber-900 underline hover:text-amber-700"
          >
            View the updated schedule →
          </Link>
        </div>

        {/* Dismiss button */}
        <button
          onClick={() => setDismissed(true)}
          aria-label="Dismiss alert"
          className="flex-shrink-0 rounded p-1 text-amber-600 hover:bg-amber-100 hover:text-amber-900 transition-colors"
        >
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  )
}
